<template>
    <div>
        <el-select
            v-model="selectTemplate"
            :disabled="isRead"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入模板名称"
            :remote-method="queryTemplateList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in archiveTemplateList"
                :key="item.id"
                :label="item.templateName"
                :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import { getArchiveTemplateList } from '@/data-model';
    // import { isEmpty } from 'lodash';

    export default {
        data () {
            return {
                loading: false,
                archiveTemplateList: [],
                selected: {
                    id: '',
                    templateName: ''
                },
                selectTemplate: ''
            };
        },
        computed: {
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            selectedNode: { // 默认选中的节点对象
                type: Object
            },
            businessTreeId: {
                type: String
            },
            isRead: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // this._setDefaultUser();
            this.queryTemplateList('');
            this._setSelectedNode();
        },
        methods: {
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.selectTemplate = this.selectedNode.id;
                }
            },
            async queryTemplateList (userName) {
                this.loading = true;
                let archiveTemplateList = await getArchiveTemplateList({ businessTreeId: this.businessTreeId, state: 1 });
                if (archiveTemplateList) {
                    this.archiveTemplateList = archiveTemplateList.data;
                }
                // console.log(this.archiveTemplateList);
                this.loading = false;
            },
            selectTrigger (val) {
                if (val) {
                    this.selected = this.archiveTemplateList.find((item) => {
                        return item.id === val;
                    });
                } else {
                    this.selected = {id: '', templateName: ''};
                }
                this.$emit('nodeClick', {id: this.selected.id, label: this.selected.templateName});
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ArchiveTemplateList/ArchiveTemplateList.vue